<template>
  <div class="viewer" style="margin-top: 100px">
    <!-- <NavBar :scroll-padding="false"></NavBar> -->
    <NavBar :scroll-padding="true" :transparent-on-top="true"></NavBar>

    <!-- Section: Video and video sidebar -->
    <vs-row style="align-items: stretch;" class="content-padding">

      <!-- Video iframe -->
      <vs-col sm="12" lg="8" w="8" class="video-padding" style="display: flex;justify-content: center;flex-direction: column;align-items: center;">
        <ServerSelector :servers="servidores" :current-server="currentURLServer" :flip="true" :change-link="changeLink" class="player-server-selector" />
        <div class="ratio ratio-16x9">
          <iframe style="width: 100%;" :src="currentURLServer" frameborder="0" allowfullscreen allow="encrypted-media" :id="'iframe'"></iframe>
        </div>
        <div style="padding-top: 1.75rem; width: 70%; text-align: center" v-if="hasFinishedLoading" class="server-selector">
          <vs-select label="Servidor" class="select-server" v-model="currentIdServer" @change="changeLinkAuto">
            <vs-option
                v-for="(serverd, index) in servidores"
                :label="serverd.ServerType"
                :value="index"
                :key="serverd.id">{{ serverd.ServerType }}</vs-option>
          </vs-select>
        </div>
      </vs-col>

      <!-- Right sidebar -->
      <vs-col lg="4" w="4" xs="12" sm="12" style="display: flex; flex-direction: column; justify-content: space-between;" class="right-sidebar-padding">
        <div class="episode-info">
          <div style="display: flex; align-items: center; justify-content: center;">
            <vs-button flat icon block @click="goToPrevEpisode">
              <i class="bx bxs-left-arrow-alt"></i> {{ $t("episode_watching.prev_episode") }}
            </vs-button>
            <vs-button flat icon warn style="padding: 0 0.8rem;" :to="mainlink">
              <i class="bx bx-list-ul"></i>
            </vs-button>
            <vs-button flat icon block @click="goToNextEpisode">
              {{ $t("episode_watching.next_episode") }} <i class="bx bxs-right-arrow-alt"></i>
            </vs-button>
          </div>
          <hr />
          <div>
            <strong><router-link :to="mainlink" style="color: #fff; text-decoration: none;">{{ serieName }}</router-link></strong> • T{{ $route.params.temporada }}E{{ $route.params.episodio }}
          </div>
          <h2 class="episode-title">{{ titleEpisode }}</h2>
          <div class="episode-description">{{ descEpisode }}</div>
        </div>

        <!-- <div class="separator" style="flex-grow: 1;"></div> -->

        <div class="fast-buttons">
          <!-- Aquí estaba el selector -->
          <vs-button-group>
            <vs-button block flat :disabled="seen.status === 1" :active="seen.status === 1" @click="markAsSeen">
              <span v-if="seen.status === 0"><i class='bx bxs-show' style="margin-right: 10px"></i> Marcar como visto</span>
              <span v-if="seen.status === 1"><i class='bx bx-check-double' style="margin-right: 10px"></i> Marcado como visto</span>
            </vs-button>
            <vs-button block flat danger @click="submitIssue">
              <i class='bx bxs-flag-alt' style="margin-right: 10px"></i> Reportar problema
            </vs-button>
          </vs-button-group>
        </div>
      </vs-col>
    </vs-row>

    <!-- Section: More info about this episode -->
    <vs-row class="content-padding" style="margin-bottom: 2rem;">
      <!-- Contextual info -->
      <vs-col w="12">
        <h4 class="section-title">{{ $t("episode_watching.about_this_episode") }} <i class="bx bx-chevron-right"></i></h4>
        <hr>
      </vs-col>
      <vs-col w="12">
        <vs-row>
          <vs-col w="2" sm="12">
            <img :src="posterSerie" style="width: 95%; max-height: 300px; object-fit: contain ">
          </vs-col>
          <vs-col w="7" style="padding-left: 10px; padding-right: 10px;" sm="10" class="about-this-episode-container">
            <!-- <strong class="noborderdown">{{ serieName }}</strong> -->
            <strong>
              <router-link :to="mainlink" style="color: #fff">{{ serieName }}</router-link>
            </strong>
            <h2 style="margin: 0">T{{ $route.params.temporada }}E{{ $route.params.episodio }} - {{ titleEpisode }}</h2>
            {{ descEpisode }}
            <br>
            <br>
            <i class="bx bx-calendar"></i> <b>Emisión:</b> {{
              (airedTimestamp === null || airedTimestamp === '') ? "Sin información" : $luxonDateTime.fromISO(airedTimestamp).toLocaleString()
            }}
            <br>
            <span class="audioInfo" v-if="hasFinishedLoading && servidores[currentIdServer].idiomas.auds.length !== 0">
            <i class="bx bx-volume-full"></i>
            <b> Audio:</b>
            <span v-for="(audio, index) in servidores[currentIdServer].idiomas.auds" v-bind:key="audio.id">
              {{ getLanguageName(audio) }}<span
                v-if="index+1 < servidores[currentIdServer].idiomas.auds.length">,</span>
            </span>
          </span>
            <br>
            <span class="audioInfo" v-if="hasFinishedLoading && servidores[currentIdServer].idiomas.subs.length !== 0">
            <i class="bx bx-message-detail"></i>
            <b> Subtítulos:</b>
            <span v-for="(sub, index) in servidores[currentIdServer].idiomas.subs" v-bind:key="sub.id">
              {{ getLanguageName(sub) }}<span v-if="index+1 < servidores[currentIdServer].idiomas.subs.length">,</span>
            </span>
          </span>
          </vs-col>
        </vs-row>
      </vs-col>
      <!-- Disqus Thread -->
      <vs-col w="12">
        <h4 class="section-title">{{ $t("episode_watching.comments") }} <i class="bx bx-chevron-right"></i></h4>
        <hr>
      </vs-col>
      <vs-col w="12">
        <div id="disqus_thread"></div>
      </vs-col>
    </vs-row>

    <form id="form_Issue" method="post" action="https://static-api.videnti.co/utility/report_issue.php" target="window_Issue">
      <input type="hidden" name="url" value="" />
      <input type="hidden" name="type" value="videnti" />
      <input type="hidden" name="accesstoken" value="" />
    </form>

    <Footer></Footer>
  </div>
</template>

<script>
import axios from "axios";
import _findKey from "lodash/findKey";
import NavBar from "../components/NavBar";
import ServerSelector from "../components/ServerSelector";
import Footer from "./Footer";
import {getLanguageName} from "../utils/helpers";

export default {
  name: "EpisodeView",
  components: {ServerSelector, NavBar, Footer},
  data() {
    return {
      episode: {},
      hasFinishedLoading: false,
      serieName: null,
      bgimg: "https://storage.googleapis.com/balde-1/various/placeholders/noimg_y.png", // 'https://i.imgur.com/Zx6wTMp.png',
      titleEpisode: null,
      backgroundSerie: null,
      posterSerie: "https://storage.googleapis.com/balde-1/various/placeholders/noimg_x.png", // 'https://i.imgur.com/1tg211q.png',
      idEpisode: null,
      descEpisode: null,
      servidores: {},
      currentURLServer: null,
      currentIdServer: 0,
      mainlink: "",
      idTemporada: null,
      episodiosTemporada: {},
      finishedFetching: false,
      airedTimestamp: null,
      typeVideo: null,
      seen: {
        status: 0,
        duration: null
      },
      lang: {
        lang: null,
        subs: [],
        auds: []
      }
    }
  },
  async created() {
    const DEBUG = true;
    const loading = this.$vs.loading({ background: '#000', color: '#fff', text: 'Cargando...' });

    await axios
        .get('https://api.videnti.co/tv/getInfo/' + this.$route.params.serie)
        .then(response => {
          if (!response.data[0]) {
            window.location = '/?error=SERIE_NO_EXISTE';
          }
          this.serieName = response.data[0].nombre;
          this.description = response.data[0].descripcion;
          this.backgroundSerie = this.getImageSource(response.data[0].images, "poster_horizontal", 'sm', response.data[0].poster_horizontal);
          this.posterSerie = this.getImageSource(response.data[0].images, "poster_vertical", 'sm', response.data[0].poster_vertical);
          // this.mainlink = window.location.origin + "/anime/" + response.data[0].url;
          this.mainlink = "/watch/" + response.data[0].url;

          if (DEBUG) { console.log("Printing show getInfo..."); console.log(response.data) }
        }).catch(error => console.log(error));

    if (this.$store.state.auth.isLoggedIn) {
      await axios
          .post(`https://api.videnti.co/tv/getEpisodeInfo/${this.$route.params.serie}/${this.$route.params.temporada}/${this.$route.params.episodio}`, new URLSearchParams(), { headers: { "Content-Type": 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + this.$store.state.auth.token } })
          .then(res => {
            if (res.data.error) { this.checkIfJWTExpired(res.data.message); }

            this.episode = res.data;
            this.seen.status = res.data.seenStatus;
            this.finishedFetching = true;
            if (DEBUG) { console.log("Printing episode getInfo..."); console.log(res.data) }
          }).catch(err => {
            switch (err.status) {
              case 404: window.location = this.mainlink + '?error=EPISODIO_NO_EXISTE'; break;
              case 500: window.location = this.mainlink; break;
            }
          });
    } else {
      await axios
          .get(`https://api.videnti.co/tv/getEpisodeInfo/${this.$route.params.serie}/${this.$route.params.temporada}/${this.$route.params.episodio}`)
          .then(res => {
            this.episode = res.data;
            this.finishedFetching = true;
            if (DEBUG) { console.log("Printing episode getInfo..."); console.log(res.data) }
          }).catch(err => {
            switch (err.status) {
              case 404: window.location = this.mainlink + '?error=EPISODIO_NO_EXISTE'; break;
              case 500: window.location = this.mainlink; break;
            }
          });
    }

    this.titleEpisode = this.episode.name;
    this.idEpisode = this.episode.episodeId;
    this.descEpisode = this.episode.description;
    this.airedTimestamp = this.episode.released;
    this.typeVideo = this.episode.type;

    document.title = this.serieName + ": T" + this.$route.params.temporada + "E" + this.$route.params.episodio + " - Ver en Videnti";

    await axios
        .get('https://api.videnti.co/episodioIframes/' + this.idEpisode)
        .then(ressIframe => {
          if (!ressIframe.data[0]) {
            window.location = this.mainlink + '?error=NO_AVAILABLE_LINKS';
          }
          this.servidores = ressIframe.data;
          this.servidores.forEach((obj, index) => {
            let indexS = index;
            this.servidores[index].idiomas = {};
            this.servidores[indexS].idiomas.subs = [];
            this.servidores[indexS].idiomas.auds = [];

            if (obj.languageCodes) {
              const split = obj.languageCodes.split(';');
              split.forEach((str) => {
                if (str.startsWith("lang:")) {
                  this.servidores[indexS].idiomas.lang = str.split(':').pop();
                } else if (str.startsWith("sub:")) {
                  this.servidores[indexS].idiomas.subs.push(str.split(':').pop());
                } else if ((str.startsWith("aud:") || str.startsWith("dub:"))) {
                  this.servidores[indexS].idiomas.auds.push(str.split(':').pop());
                }
              })
            }
          })

          if (DEBUG) { console.log("Printing iframes info..."); console.log(ressIframe.data) }
        })
    this.currentURLServer = this.servidores[0].IframeURL;
    this.hasFinishedLoading = true;
    await axios
        .get('https://api.videnti.co/temporadaBySerie/' + this.$route.params.serie + "/" + this.$route.params.temporada)
        .then(ressTemp => {
          this.idTemporada = ressTemp.data[0].idTemporada;
        });
    await axios
        .get('https://api.videnti.co/episodiosInfo/' + this.idTemporada)
        .then(ress => {
          // const i = obj.number;
          // console.log(ress.data[0]);
          this.episodiosTemporada = ress.data;
        });

    // await document.querySelector(".blackCard").scrollIntoView({ inline: "center", block: 'nearest' });

    // Disabled for while...
    // document.querySelector(".vs-card__group-cards").scrollLeft = document.querySelector(".blackCard").offsetLeft;

    // document.querySelector(".vs-card__group-cards").scrollTop = document.querySelector(".blackCard").offsetTop;

    // eslint-disable-next-line no-unused-vars
    // var disqus_developer = 1;
    (function() { // DON'T EDIT BELOW THIS LINE
      var d = document, s = d.createElement('script');
      s.src = 'https://videnti.disqus.com/embed.js';
      s.setAttribute('data-timestamp', +new Date());
      (d.head || d.body).appendChild(s);
    })();

    // this.intervalCheckerTime = setInterval(this.checkerTime());
    loading.close();
  },
  methods: {
    getLanguageName,
    submitIssue() {
      let f = document.getElementById('form_Issue');
      f.url.value = window.location.href;
      f.accesstoken.value = this.$store.state.auth.token;
      window.open('', 'window_Issue');
      f.submit();
    },
    changeLink(i) {
      this.currentURLServer = this.servidores[i].IframeURL;
      this.currentIdServer = i;
    },
    changeLinkAuto() {
      this.currentURLServer = this.servidores[this.currentIdServer].IframeURL;
    },
    goToNextEpisode() {
      let index = _findKey(this.episodiosTemporada, ['idEpisodio', this.idEpisode]);
      if (!this.episodiosTemporada[parseInt(index) + 1]) { // parseFloat
        this.$vs.notification({
          // 1000,
          progress: 'auto',
          color: "danger",
          duration: "6000",
          title: '',
          text: `<iframe width="300" height="165" src="https://www.youtube-nocookie.com/embed/uWfbR_juSdY?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>`
        })
      } else {
        // window.location = this.mainlink + "/" + this.$route.params.temporada + "/" + (parseInt(this.$route.params.episodio) + 1);
        window.location = this.mainlink + "/" + this.$route.params.temporada + "/" + (this.episodiosTemporada[parseInt(index) + 1].number);
      }
      // console.log('Current episode belongs to: ' + _findKey(this.episodiosTemporada, ['idEpisodio', this.idEpisode]))
      // this.$router.push({ name: 'episodeview', params: { serie: this.$route.params.serie, temporada: this.$route.params.temporada, episodio: (parseInt(this.$route.params.episodio) + 1)} });
      // window.location = this.mainlink + "/" + this.$route.params.temporada + "/" + (parseInt(this.$route.params.episodio) + 1);
    },
    goToPrevEpisode() {
      let index = _findKey(this.episodiosTemporada, ['idEpisodio', this.idEpisode]);
      if (!this.episodiosTemporada[parseInt(index) - 1]) {
        this.$vs.notification({
          // 1000,
          progress: 'auto',
          color: "danger",
          duration: "6000",
          title: '',
          text: `<iframe width="300" height="165" src="https://www.youtube-nocookie.com/embed/uWfbR_juSdY?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>`
        })
      } else {
        window.location = this.mainlink + "/" + this.$route.params.temporada + "/" + (this.episodiosTemporada[parseInt(index) - 1].number);
        // window.location = this.mainlink + "/" + this.$route.params.temporada + "/" + (parseInt(this.$route.params.episodio) - 1);
      }
      // this.$router.push({ name: 'episodeview', params: { serie: this.$route.params.serie, temporada: this.$route.params.temporada, episodio: (parseInt(this.$route.params.episodio) - 1)} });
      // window.location = this.mainlink + "/" + this.$route.params.temporada + "/" + (parseInt(this.$route.params.episodio) - 1);
    },
    goToEpisodeThisTemporada(episodio) {
      if (window.location.pathname.endsWith("/")) {
        window.location = this.mainlink + "/" + this.$route.params.temporada + "/" + episodio;
      } else {
        window.location = this.mainlink + "/" + this.$route.params.temporada + "/" + episodio;
      }
    },
    /* imageUrlAlt(event) {
      event.target.src = "https://i.imgur.com/Zx6wTMp.png"
    }, */
    async markAsSeen() {
      if (this.$store.state.auth.isLoggedIn) {
        const params = new URLSearchParams();
        params.append('episode', this.idEpisode);
        params.append('status', "1");

        await axios
            .post(`https://api.videnti.co/user/updateEpisodeStatus`,
                params,
                { headers: { "Content-Type": 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + this.$store.state.auth.token, } }
            ).then(res => {
              if (res.data.error === true) {
                this.$vs.notification({
                  progress: 'auto', color: "danger", duration: "10000",
                  title: (res.data.title ? res.data.title : 'Ocurrió un error'),
                  text: `${res.data.message}`
                })
              } else {
                console.log(res.data);
                this.seen.status = 1;

                /* this.$vs.notification({
                  progress: 'auto', color: (res.data.color ? res.data.color : "success"), duration: "10000",
                  title: (res.data.title ? res.data.title : 'Información'),
                  text: `Has marcado este episodio como visto.`
                }) */
              }
            });
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalCheckerTime());
  }
}
</script>

<!-- Local style -->
<style scoped lang="scss">
@import "~@elbuenanvita/vuesax/src/styles/mixins";

.content-padding {
  padding: 0 5rem;

  @include media-breakpoint-down("md") {
    padding: 0 1rem;
  }
}

.video-padding {
  padding: 0 1rem 0 0;
  @include media-breakpoint-down("md") { padding: 0; }
}

.right-sidebar-padding {
  padding: 0 1rem;
  @include media-breakpoint-down("md") { padding: 1rem 0 0 0; }
}

.episode-info {
  .episode-title {
    font-size: 1.5em;
    font-weight: 600;
    margin: 0
  }

  .episode-description {
    font-weight: 400;
    font-size: .85em;
    color: #aeb2b4;
    line-height: 1.25rem;
  }
}

.server-selector {
  display: none;
  @include media-breakpoint-down("md") {
    display: block;
  }
}

.player-server-selector {
  @include media-breakpoint-down("md") {
    display: none !important;
  }
  place-self: start;
}

h4.section-title {
  margin-block-start: 2em;
  margin-block-end: 0;

  @include media-breakpoint-down("md") {
    margin-block-start: 4em;
  }
}

hr {
  border: 1px solid #3e3e3e;
  border-radius: 1px;
}

.about-this-episode-container {
  color: rgb(var(--vs-text-dark-3));
}

</style>

<!-- Global style -->
<style lang="scss">
.select-server .vs-select:not(.activeOptions) .vs-select__input {
  border-color: #222324;
}
</style>

<style>
body {
  margin: 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
.blackCard > .vs-card {
  /* background: #2c3e50;
  color: aliceblue; */
  opacity: 0.3;
  pointer-events: none;
}
.widthRemove {
  width: auto !important;
}

/* Responsive embeds */
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item, .embed-responsive iframe, .embed-responsive embed, .embed-responsive object, .embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.embed-responsive-21by9::before {
  padding-top: 42.8571428571%;
}
.embed-responsive-16by9::before {
  padding-top: 56.25%;
}
.embed-responsive-4by3::before {
  padding-top: 75%;
}
.embed-responsive-1by1::before {
  padding-top: 100%;
}
</style>
